package org.gstechnovos.jexonplastech.pages

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.rememberPageContext
import com.varabyte.kobweb.silk.components.text.SpanText
import org.gstechnovos.jexonplastech.components.layouts.PageLayout
import org.gstechnovos.jexonplastech.sections.product_details.sections.ProductDetailsContent
import org.gstechnovos.jexonplastech.sections.products.model.GlobalCatalog
import org.gstechnovos.jexonplastech.sections.products.model.Product

@Page("/products/{model}")
@Composable
fun ProductDetailsPage() {
    val ctx = rememberPageContext()
    val modelNumber = ctx.route.params["model"] ?: ""

    // Fetch the product directly from the shared catalog database
    var product by remember { mutableStateOf<Product?>(null) }

    LaunchedEffect(modelNumber) {
        if (modelNumber.isNotEmpty()) {
            product = GlobalCatalog.getProductByModel(modelNumber)
        }
    }

    PageLayout {
        product?.let { currentProduct ->
            ProductDetailsContent(currentProduct)
        } ?: run {
            SpanText("Loading or Product Not Found...")
        }
    }
}